const videoVariants = {
	YOUTUBE: 'youtube',
	VIMEO: 'vimeo',
};

export default videoVariants;
